import React, { useState } from 'react';
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import { message, Upload } from 'antd';
import type { UploadChangeParam } from 'antd/es/upload';
import type { RcFile, UploadFile, UploadProps } from 'antd/es/upload/interface';
import { BaseUrlGeneral, getToken } from '../../../../../utils';

const beforeUpload = (file: RcFile) => {
  const isPdf = file.type === 'application/pdf';
  if (!isPdf) {

    message.error('You can only upload PDF file!');
    return false;
  }
  if (file.size > 2000000) {
    message.error('You can only upload file of size less than 2MB!');
    return false
  }

  return true;
};

const ResumeUploadAvatar: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [fileUrl, setFileUrl] = useState<string>();

  const handleChange: UploadProps['onChange'] = (
    info: UploadChangeParam<UploadFile>
  ) => {
    if (info.file.status === 'uploading') {
      setLoading(true);
      return;
    }
    if (info.file.status === 'error') {
      message.error(`${info.file.name} 
                       file upload failed.`);
      setLoading(false);
    }
    if (info.file.status === 'done') {
      message.success(`${info.file.name} 
        file uploaded successfully`);

      // Get this url from response in real world.
      setLoading(false);
      window.location.reload();
    }
  };

  const uploadButton = (
    <div>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>
  );

  return (
    <Upload
      name="file"
      listType="picture-card"
      className="avatar-uploader"
      showUploadList={false}
      method="POST"
      headers={{ Authorization: '' + getToken() }}
      action={BaseUrlGeneral + '/api/v1/profile/files/upload-resume'}
      beforeUpload={beforeUpload}
      onChange={handleChange}
    >
      {fileUrl ? (
        <img src={fileUrl} alt="avatar" style={{ width: '100%' }} />
      ) : (
        uploadButton
      )}
    </Upload>
  );
};

export default ResumeUploadAvatar;
